var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.opened
    ? _c("div", { staticClass: "modal-mask" }, [
        _c("div", { staticClass: "modal-wrapper" }, [
          _c(
            "div",
            { staticClass: "modal-dialog modal-xl modal-dialog-scrollable" },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("h5", { staticClass: "modal-title" }, [
                    _vm._v("Criteria templates"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: { type: "button" },
                      on: { click: _vm.close },
                    },
                    [_vm._v("×")]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  !_vm.initialized
                    ? _c("h3", [
                        _c("i", { staticClass: "fa fa-spinner fa-spin" }),
                        _vm._v(" Loading... "),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.initialized
                    ? _c("div", [
                        _c("div", { staticClass: "dropdown" }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-outline-secondary dropdown-toggle",
                              attrs: {
                                type: "button",
                                "data-toggle": "dropdown",
                              },
                            },
                            [_c("span", [_vm._v(_vm._s(_vm.categoryLabel))])]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "dropdown-menu" },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  on: {
                                    click: function ($event) {
                                      _vm.selectedCategory = null
                                    },
                                  },
                                },
                                [_vm._v("All templates")]
                              ),
                              _vm._v(" "),
                              _c("h6", { staticClass: "dropdown-header" }, [
                                _vm._v("Categories:"),
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.categories, function (c) {
                                return _c(
                                  "a",
                                  {
                                    staticClass: "dropdown-item",
                                    on: {
                                      click: function ($event) {
                                        _vm.selectedCategory = c
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(c))]
                                )
                              }),
                            ],
                            2
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "row" },
                          _vm._l(_vm.templatesView, function (item) {
                            return _c(
                              "div",
                              {
                                staticClass:
                                  "col-lg-4 col-md-4 col-sm-6 col-xs-12",
                              },
                              [
                                _c("div", { staticClass: "card mt-3" }, [
                                  _c(
                                    "div",
                                    { staticClass: "card-header text-center" },
                                    [
                                      _c("span", [
                                        _vm._v(_vm._s(item.Category || " ")),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "card-body",
                                      staticStyle: {
                                        "max-height": "250px",
                                        height: "250px",
                                        "overflow-y": "auto",
                                      },
                                    },
                                    [
                                      _c("h5", { staticClass: "card-title" }, [
                                        _vm._v(_vm._s(item.Name)),
                                      ]),
                                      _vm._v(" "),
                                      _c("p", { staticClass: "card-text" }, [
                                        _vm._v(_vm._s(item.Description)),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "a",
                                        {
                                          staticClass: "text-primary",
                                          attrs: {
                                            title: "View scale template",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.emitShowScale(
                                                item.ScaleTemplate
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              "Default scale: " +
                                                _vm._s(item.ScaleTemplateName)
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "card-footer text-center" },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "btn btn-outline-secondary",
                                          attrs: { disabled: item.Used },
                                          on: {
                                            click: function ($event) {
                                              return _vm.emitCreateCriterion(
                                                item
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                            " +
                                              _vm._s(
                                                item.Used ? "Added" : "Create"
                                              ) +
                                              "\n                                        "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            )
                          }),
                          0
                        ),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-secondary",
                      attrs: { type: "button" },
                      on: { click: _vm.close },
                    },
                    [_vm._v("Close")]
                  ),
                ]),
              ]),
            ]
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }